module.exports = "/_next/static/images/AustinLogo-97e3468df142c234c3cd5a016a00d153.png";